import React from "react"
import PropTypes from "prop-types"

// Import Components
import RuleListStyle from "./style"
import RuleListItem from "./RuleListItem"

ScraperRuleList.propTypes = {
  // Import Components
  type: PropTypes.string,
  buttonDelete_clickHandler: PropTypes.func
}

function ScraperRuleList({ type, items }) {
  const listElements = items.map(({ value, label, total_scraped_products, last_upload_date, can_parse, ...restProps }, index) => {
    return (
      <li className="design-rule__item" key={value || index}>
        <RuleListItem
          type={type}
          title={label}
          id={value}
          total_scraped_products={total_scraped_products}
          last_upload_date={last_upload_date}
          can_parse={can_parse}
          collection={restProps}
        />
      </li>
    )
  })

  const emptyItems = <p>No data to display</p>

  return (
    <RuleListStyle>
      <ul className="design-rule__list">
        {items.length ? listElements : emptyItems}
      </ul>
    </RuleListStyle>
  )
}

export default ScraperRuleList
